import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Stat from '../../../components/shared/Stat';
import LineChart from '../../../components/shared/LineChart';
import * as actions from '../../../redux/actions';
import { getAccountsCreatedCharts } from '../../../redux/reducers';
import { formatTimestamp } from '../../../utils';
import LoadingIndicator from "../../../components/containers/LoadingIndicator";

class AccountCreationChart extends Component {
	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.period !== prevProps.period) {
			this.fetchData();
		}
	}

	fetchData() {
		const { fetchAccountsCreated, period } = this.props;
		fetchAccountsCreated({period});
	}
	render() {
		const { volume: { totalSum, /* totalCount,*/ pctChange, data }, period } = this.props;
		const formatter = (date) => formatTimestamp(date, period);
		const valueFormatter = (value, name, props) => [new Intl.NumberFormat('en').format(value) + ' accounts'];
		if (!this.props.volume.loading) {
			return (
				data && data.length ?
					<Fragment>
						<Stat count={totalSum} pct={pctChange} label="accounts" />
						<br />
						<LineChart
							graphType={this.props.graphType}
							data={data}
							tickFormatter={formatter}
							labelFormatter={formatter}
							valueFormatter={valueFormatter}
						/>
					</Fragment>
				:  <div>No Accounts available for the selected period</div>
			);
		} else {
			return <LoadingIndicator />
		}
	}
}

const mapStateToProps = (state) => ({
	volume: getAccountsCreatedCharts(state)
});

AccountCreationChart = connect(mapStateToProps, actions)(AccountCreationChart);

export default AccountCreationChart;
